module.exports = "<div class=\"rate-components\">\n  <div class=\"current-rate\">1.0x</div>\n  <ul class=\"rate-list\">\n    <li data-rate=\"2.0\">2.0x</li>\n    <li data-rate=\"1.5\">1.5x</li>\n    <li data-rate=\"1.25\">1.25x</li>\n    <li data-rate=\"1.0\" class=\"current\">1.0x</li>\n    <li data-rate=\"0.5\">0.5x</li>\n  </ul>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./src/pages/lesson/play/components/aliplayer/components/RateComponent/index.html
// module id = lBDg
// module chunks = 2